/// <reference path="../../../data/DataModels/types.d.ts" />
import React from 'react';
import '../../Styles/EventPrimaryFormSection.css';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import { getEvent, cancelEvent, deleteEvent } from '../../../data/EventRepository';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import { EventClusterPermissionCode } from "../../../data/Models/EventClusterPermissionCode";
import { EventClusterPermission } from '../../../data/Models/EventClusterPermission';
import { GenericConfirmationModal } from '../GenericConfirmationModal';
import { GenericSuccessModal } from '../GenericSuccessModal';
import { GenericErrorModal } from '../GenericErrorModal';
import { EventStatusCode } from '../../../data/Models/Enums';
import { Chip } from '@material-ui/core';
var Enumerable = require('linq');

interface IPublishSectionProps {
    userPermissions: any[],
    isClusterOwner: boolean,
    loadingOn: () => void,
    loadingOff: () => void,
    publishEvent: (eventId: string) => void,
    publishValidationErrors: any[],
    publishSuccess: boolean,
    changePage: (page: string) => void
}

export class PublishSection extends React.Component<IPublishSectionProps>{

    state = {
        eventId: '',
        eventWebsiteLink: '',
        eventDeepLink: '',
        eventClusterId: '',
        published: false,
        serverError: '',
        showPublishConfirmationModal: false,
        cancelled: false,
        cancelEventModalVisible: false,
        cancelEventSuccess: false,
        deleteEventModalVisible: false,
        deleteEventSuccess: false,
        allOrdersRefundedSuccessfully: true,
    }

    async componentDidMount() {
        await this.LoadPage();
    }

    LoadPage = async () => {
        this.props.loadingOn();

        const query = new URLSearchParams(window.location.search);

        let id = query.get('id');
        let eventWebsiteLink = process.env.REACT_APP_NRBY_EVENT_TICKETPURCHASE_LINK;
        let eventDeepLink = process.env.REACT_APP_NRBY_EVENT_DEEPLINK;
        let eventClusterId: string = query.get('eventGroupId') ?? "";
        let serverError = '';
        let published = false;
        let cancelled = false;

        if (id == undefined || id == '' || eventClusterId == undefined || eventClusterId == '') {
            serverError = "Event Id and Event Group Id are required.";
        }
        else {
            var eventResponse = await getEvent(id);

            if (eventResponse != null && eventResponse.status == 401) {
                this.RedirectToLogin(eventClusterId, id);
            }
            else if (eventResponse != null && eventResponse.status == 200) {
                if (!eventResponse.data.success) {
                    serverError = eventResponse.data.errorMsg;
                }
                else {
                    var event = eventResponse.data.event;

                    id = event.id;
                    eventWebsiteLink = eventWebsiteLink?.replace("{id}", event.id);
                    eventDeepLink = eventDeepLink?.replace("{id}", event.id);
                    published = event.published;
                    cancelled = event.cancelled;
                }
            }
            else {
                serverError = "An unknown error occured. Please try again later";
            }
        }

        this.setState({ ...this.state, eventId: id, eventWebsiteLink: eventWebsiteLink, eventDeepLink: eventDeepLink, eventClusterId: eventClusterId, published: published, serverError: serverError, cancelled: cancelled });

        this.props.loadingOff();
    }

    RedirectToLogin = (eventClusterId: any, eventId: any) => {
        let eventClusterParam = eventClusterId != null && eventClusterId != "" ? `?eventGroupId=${eventClusterId}` : "";

        if (eventId != '' && eventId != undefined) {
            eventClusterParam += `%26id=${eventId}`;
        }

        this.props.changePage("/login?redirect=event" + eventClusterParam);
    }

    CloseSaveSuccessModal = () => {
        this.setState({ ...this.state, saveSuccess: false });
    }

    CloseSaveErrorModal = () => {
        this.setState({ ...this.state, saveError: '' });
    }

    HandlePublishEventClick = () => {
        this.setState({ ...this.state, showPublishConfirmationModal: true });
    }

    HandlePublishEvent = async () => {
        this.setState({ ...this.state, showPublishConfirmationModal: false });
        await this.props.publishEvent(this.state.eventId);
        await this.LoadPage();
    }

    CancelPublishEvent = () => {
        this.setState({ ...this.state, showPublishConfirmationModal: false });
    }

    CancelEvent = async () => {
        this.setState({ ...this.state, cancelEventModalVisible: true });
    }

    OnCloseCancelModal = () => {
        this.setState({ ...this.state, cancelEventModalVisible: false });
    }

    HandleCancelEvent = async () => {
        this.props.loadingOn();

        var response = await cancelEvent(this.state.eventId);
        let serverError = '';
        let cancelEventSuccess = false;

        let allOrdersRefundedSuccessfully = true;

        if (response != null && response.status == 401) {
            this.props.changePage("/login?redirect=all-events");
        }
        else if (response != null && response.status == 200) {
            if (!response.data.success) {
                serverError = response.data.errorMsg;
            }
            else {
                cancelEventSuccess = true;
                allOrdersRefundedSuccessfully = response.data.allOrdersRefundedSuccessfully;
            }
        }
        else {
            serverError = "An unknown error occured. Please try again later";
        }
        this.setState({ ...this.state, serverError: serverError, deleteEventModalVisible: false, cancelEventSuccess: cancelEventSuccess, cancelEventModalVisible: false, allOrdersRefundedSuccessfully: allOrdersRefundedSuccessfully }, async () => {
            if (cancelEventSuccess) {
                await this.LoadPage();
            }
            this.props.loadingOff();
        });

    }

    CloseSuccessModal = () => {
        this.setState({ ...this.state, cancelEventSuccess: false });
    }

    DeleteEventClick = (eventId: any) => {
        this.setState({ ...this.state, deleteEventModalVisible: true });
    }

    CloseDeleteEventModal = () => {
        this.setState({ ...this.state, deleteEventModalVisible: false });
    }

    DeleteEvent = async () => {
        this.props.loadingOn();
        var response = await deleteEvent(this.state.eventId);
        let serverError = '';

        let deleteEventSuccess = false;

        if (response != null && response.status == 401) {
            this.props.changePage("/login?redirect=event-group" + this.state.eventClusterId);
        }
        else if (response != null && response.status == 200) {
            if (!response.data.success) {
                serverError = response.data.errorMsg;
            }
            else {
                deleteEventSuccess = true;
            }
        }
        else {
            serverError = "An unknown error occured. Please try again later";
        }
        this.setState({ ...this.state, serverError: serverError, deleteEventModalVisible: false, deleteEventSuccess: deleteEventSuccess });
        this.props.loadingOff();
    }

    CloseSuccessDeleteModal = () => {
        this.props.changePage("/all-events");
    }

    CloseRefundErrorModal = () => {
        this.setState({ ...this.state, allOrdersRefundedSuccessfully: true });
    }


    render() {
        var canEdit = this.props.isClusterOwner || Enumerable.from(this.props.userPermissions).any((p: EventClusterPermission) => p.id == EventClusterPermissionCode.EditEvents);
        let deleteEventAccess = this.props.isClusterOwner || Enumerable.from(this.props.userPermissions).any((p: EventClusterPermission) => p.id == EventClusterPermissionCode.DeleteOrCancelEvents);
        
        return (
            <div style={{ height: '90%', width: "100%" }}>
                <div style={{ width: "100%", maxHeight: "100%", overflowY: "scroll" }}>
                    <Card style={{ height: '90%', backgroundColor: "#ededed" }}>
                        <CardContent >
                            <div style={{ marginBottom: "20px" }}>
                                {!this.state.published && !this.props.publishSuccess && <Button variant="contained" className='btn-primary' style={{ verticalAlign: "middle" }} onClick={this.HandlePublishEventClick} disabled={!canEdit} >
                                    Publish Event
                                </Button>}
                            </div>
                            <div>
                                {this.state.cancelled && <div><Chip label="Event Cancelled" color='secondary' /></div>}
                                {(this.props.publishSuccess || this.state.published) && <div>
                                    <div style={{ color: "limegreen", height: "100%" }}>
                                        <span style={{ height: "100%", verticalAlign: "middle" }}><DoneOutlineIcon /></span>
                                        <span style={{ height: "100%", verticalAlign: "middle", marginLeft: "5px" }}>Event Published</span>
                                    </div>
                                    <div style={{ marginTop: "40px", fontSize: "20px" }}>
                                        <tr>
                                            <td style={{ fontWeight: "bold" }}>Event Website Link:</td>
                                            <td><a href={this.state.eventWebsiteLink}>{this.state.eventWebsiteLink}</a></td>
                                        </tr>
                                    </div>
                                    <div style={{ marginTop: "40px", fontSize: "20px" }}>
                                        <tr>
                                            <td style={{ fontWeight: "bold" }}>Event App Link:</td>
                                            <td><a href={this.state.eventDeepLink}>{this.state.eventDeepLink}</a></td>
                                        </tr>
                                    </div>
                                </div>
                                }
                                {this.props.publishValidationErrors.length > 0 &&
                                    this.props.publishValidationErrors.map((error: any) => (
                                        <div style={{ color: "red" }}>
                                            {error}
                                        </div>
                                    ))
                                }
                            </div>
                            <div style={{ marginTop: "200px" }}>
                                {this.state.published && !this.state.cancelled && deleteEventAccess && <div>
                                        <Button variant="contained" className="btn-primary" onClick={this.CancelEvent}>
                                            Cancel Event
                                        </Button>
                                    </div>}
                                {!this.state.published && deleteEventAccess && <div>
                                    <Button variant="contained" className="btn-primary" onClick={this.DeleteEventClick}>
                                        Delete Event
                                    </Button>
                                </div>}
                            </div>
                        </CardContent>
                        <CardContent>
                            <div style={{ color: 'red' }} hidden={this.state.serverError == ''}>
                                {this.state.serverError}
                            </div>
                        </CardContent>
                    </Card>
                </div>
                <GenericConfirmationModal hidden={!this.state.showPublishConfirmationModal}
                    cancelButtonText="No, Cancel" confirmButtonText="Yes, Publish"
                    onConfirm={this.HandlePublishEvent}
                    closeModal={this.CancelPublishEvent}
                    message="Are you sure you want to publish this event? Once published you will be unable to edit any fields other than Event Description, Keywords or Image. You can also add/edit ticket options still but you can not delete ticket options."
                />
                <GenericConfirmationModal hidden={!this.state.cancelEventModalVisible}
                    cancelButtonText="No" confirmButtonText="Yes"
                    onConfirm={this.HandleCancelEvent}
                    closeModal={this.OnCloseCancelModal}
                    message="Are you sure that you want to cancel this event? Any tickets currently purchased for this event will be automatically refunded without the Processing Fee we charge to cover the cost Stripe Processing Fees and Account Payout Fees. This Processing Fee equates to $0.30 plus 3.25% * (Ticket Price + Service Fee + Sales Tax) per Order."
                />
                <GenericConfirmationModal hidden={!this.state.deleteEventModalVisible}
                    cancelButtonText="No" confirmButtonText="Yes"
                    onConfirm={this.DeleteEvent}
                    closeModal={this.CloseDeleteEventModal}
                    message="Are you sure that you want to delete this event?"
                />
                <GenericSuccessModal
                    hidden={this.state.cancelEventSuccess == false}
                    message={"The event was cancelled successfully."}
                    closeModal={this.CloseSuccessModal}
                />
                <GenericSuccessModal
                    hidden={this.state.deleteEventSuccess == false}
                    message={"The event was deleted successfully."}
                    closeModal={this.CloseSuccessDeleteModal}
                />
                <GenericErrorModal hidden={this.state.allOrdersRefundedSuccessfully}
                    message="Some orders didn't get refunded successfully. Please contact us at support@nrby.io to get the remaining orders refunded."
                    closeModal={this.CloseRefundErrorModal} />
            </div>

        );
    }
}